import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { IModules, IStation } from "../../../../models/IUser";
import { DeviceTypeConfig, isStationVisible } from "../deviceTypeConfig";
import {
  updateItemWithModified,
  resetModified,
  filterModified,
  WithModified,
  deepClone,
} from "../utils/modifiedFields";

export function useStationsState(
  module: IModules | null,
  stations: IStation[],
  config: DeviceTypeConfig,
  markMutated: () => void,
) {
  const [stationsState, setStationsState] = useState<WithModified<IStation>[]>(
    [],
  );

  // `G.2`: у МДБН-9 в таблице только те адреса, что есть в шкафу. Данные станции
  // при этом не трогаются — скрыт только показ.
  const stationsToDisplay =
    module && config.tableMode === "stations"
      ? stations.filter(
          (el) =>
            el.module_id === module.id &&
            isStationVisible(module.cabinet_model, el.controller_address),
        )
      : [];

  useEffect(() => {
    setStationsState(
      stationsToDisplay.map((station) => ({
        ...deepClone(station),
        __modified: [],
      })),
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [stations, module?.id]);

  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement>,
    stationId?: number,
  ) => {
    if (stationId === undefined) return;

    markMutated();
    const { name, value } = e.target;

    if (name === "controller_address") {
      const num = parseInt(value, 10);
      if (isNaN(num) || num < 1 || num > 15) {
        toast.error("Значение адреса контроллера должно быть от 1 до 15");
      }
    }

    setStationsState((prevList) =>
      prevList.map((station) =>
        station.id === stationId
          ? updateItemWithModified(station, name, value)
          : station,
      ),
    );
  };

  const reset = () => {
    setStationsState((prev) => prev.map(resetModified));
  };

  return {
    stationsState,
    handleChange,
    reset,
    modifiedStations: filterModified(stationsState),
  };
}
